import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import { serverRequest } from 'app/requests/serverRequest';
import { buildParams } from 'app/utils/pagination';
import env from '.env.json';

export const getListens = async (params, token = '') => {
  const paramsUrl = buildParams(params);
  const path = `/api/listens/search${paramsUrl}`;
  const listens = await serverRequest(path, 'post', token, {}, env.URL_API_NODE) as ResultAPI;
  return listens.data;
};

export const getByListenSlug = async (slug: string, code: string) => {
  const paramsUrl = buildParams({ code });
  const listen = await apiRequest(`/api/listens/${slug}${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return listen.data;
};

export const getMusic = async (params: string) => {
  const paramsUrl = buildParams(params);
  const result = await apiRequest(`/api/musics/search/${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const getSongs = async (params) => {
  const result = await apiRequest(`/api/musics/song/search`, 'post', params, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const infoSong = async (slug: string, code: string) => {
  const paramsUrl = buildParams({ code });
  const result = await apiRequest(`/api/musics/song/info/${slug}${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const updateSongHot = async (id: string) => {
  return await apiRequest(`/api/musics/song/info/${id}`, 'put', {}, false, env.URL_API_NODE);
};

export const getSingers = async (params) => {
  const paramsUrl = buildParams(params);
  const result = await apiRequest(`/api/musics/singers/${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const infoSinger = async (slug: string, code: string) => {
  const paramsUrl = buildParams({ code });
  const result = await apiRequest(`/api/musics/singers/${slug}${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const getVideos = async (type: string, params, token: string = '') => {
  const paramsUrl = buildParams(params);
  const result = await serverRequest(`/api/videos/${type}/search${paramsUrl}`, 'get', token, {}, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const infoVideo = async (type: string, slug: string, code: string) => {
  const paramsUrl = buildParams({ code });
  const url = `/api/videos/info/${type}/${encodeURIComponent(slug)}${paramsUrl}`;
  const result = await apiRequest(url, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const getQuotations = async (params: string) => {
  const paramsUrl = buildParams(params);
  const result = await apiRequest(`/api/quotations/search${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const getJokes = async (params) => {
  const paramsUrl = buildParams(params);
  const result = await apiRequest(`/api/jokes/search${paramsUrl}`, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};

export const infoJoke = async (slug: string, code: string) => {
  const paramsUrl = buildParams({ code });
  const url = `/api/jokes/info/${encodeURIComponent(slug)}${paramsUrl}`;
  const result = await apiRequest(url, 'get', {}, false, env.URL_API_NODE) as ResultAPI;
  return result.data;
};
